import gql from 'graphql-tag';

export default gql`
subscription {
    onCreateWebsite {
        __typename
        id
        name
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Websites/NewSubscription.js